import React, { useEffect, useState } from 'react';
import { CloudOff, AlertTriangle, X } from 'lucide-react';
import { EVENTO_ESCRITURA_FALLIDA, sinConexion } from '../config/escrituras';

/**
 * Sin red se puede seguir apuntando: Firestore lo guarda en el dispositivo y lo
 * sube al volver la conexión (ver config/escrituras.ts). Este aviso lo explica
 * mientras no hay red, y avisa si algo de lo guardado así no se pudo subir.
 */
export const AvisoSinConexion: React.FC = () => {
  const [offline, setOffline] = useState(sinConexion);
  const [fallo, setFallo] = useState(false);

  useEffect(() => {
    const cambio = () => setOffline(sinConexion());
    const falla = () => setFallo(true);
    window.addEventListener('online', cambio);
    window.addEventListener('offline', cambio);
    window.addEventListener(EVENTO_ESCRITURA_FALLIDA, falla);
    return () => {
      window.removeEventListener('online', cambio);
      window.removeEventListener('offline', cambio);
      window.removeEventListener(EVENTO_ESCRITURA_FALLIDA, falla);
    };
  }, []);

  if (!offline && !fallo) return null;

  return (
    <div className="max-w-7xl mx-auto px-4 pt-4 space-y-2">
      {offline && (
        <div role="status" className="flex gap-3 rounded-xl border border-gray-200 dark:border-gray-700
                        bg-white dark:bg-gray-800 px-4 py-3">
          <CloudOff className="w-5 h-5 text-gray-500 dark:text-gray-400 flex-shrink-0 mt-0.5" />
          <div className="min-w-0">
            <p className="text-sm font-semibold text-gray-900 dark:text-white">Sin conexión</p>
            <p className="text-xs text-gray-600 dark:text-gray-400 mt-0.5">
              Puedes seguir apuntando: se guarda en este dispositivo y se sube solo cuando vuelva la red.
            </p>
          </div>
        </div>
      )}
      {fallo && (
        <div role="alert" className="flex gap-3 rounded-xl border border-red-200 dark:border-red-800
                        bg-red-50 dark:bg-red-900/20 px-4 py-3">
          <AlertTriangle className="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" />
          <div className="flex-1 min-w-0">
            <p className="text-sm font-semibold text-red-900 dark:text-red-200">Un cambio no se ha podido guardar</p>
            <p className="text-xs text-red-800 dark:text-red-300 mt-0.5">
              Se hizo sin conexión y, al subirlo, no se aceptó. Ya no aparece en la lista: revísalo y vuelve a apuntarlo.
            </p>
          </div>
          <button type="button" onClick={() => setFallo(false)} aria-label="Cerrar aviso"
            className="p-1 -m-1 h-fit rounded text-red-700 dark:text-red-300 hover:bg-red-100 dark:hover:bg-red-900/40">
            <X className="w-4 h-4" />
          </button>
        </div>
      )}
    </div>
  );
};
